import { Route, useParams } from 'react-router-dom';
import Bancos from '../pages/Bancos';
import CajaChica from '../pages/CajaChica';
import DetalleCliente from '../pages/clientes/DetalleCliente';
import EditarCliente from '../pages/clientes/EditarCliente';
import EliminarCliente from '../pages/clientes/EliminarCliente';
import ListaClientes from '../pages/clientes/ListaClientes';
import NuevoCliente from '../pages/clientes/NuevoCliente';
import Referencias from '../pages/clientes/Referencias';
import CobrosHoy from '../pages/CobrosHoy';
import Configuracion from '../pages/Configuracion';
import Contabilidad from '../pages/Contabilidad';
import CalculadoraCuota from '../pages/contabilidad/CalculadoraCuota';
import CuadrePagos from '../pages/contabilidad/CuadrePagos';
import CuadreRutas from '../pages/contabilidad/CuadreRutas';
import CuadreCaja from '../pages/CuadreCaja';
import CuentasPagar from '../pages/CuentasPagar';
import Dashboard from '../pages/Dashboard';
import DebenPagar from '../pages/DebenPagar';
import Documentos from '../pages/Documentos';
import Facturas from '../pages/Facturas';
import Finanzas from '../pages/Finanzas';
import FlujoCaja from '../pages/FlujoCaja';
import Garantias from '../pages/Garantias';
import Gastos from '../pages/Gastos';
import GestionExcusas from '../pages/GestionExcusas';
import GestionRutas from '../pages/GestionRutas';
import MetasComisiones from '../pages/MetasComisiones';
import Pagos from '../pages/Pagos';
import Permisos from '../pages/Permisos';
import PorRecoger from '../pages/PorRecoger';
import Prestamos from '../pages/Prestamos';
import EditarPrestamo from '../pages/prestamos/EditarPrestamo';
import EliminarPrestamo from '../pages/prestamos/EliminarPrestamo';
import EliminarReenganche from '../pages/prestamos/EliminarReenganche';
import ListaPrestamos from '../pages/prestamos/ListaPrestamos';
import NuevoPrestamo from '../pages/prestamos/NuevoPrestamo';
import Reenganche from '../pages/prestamos/Reenganche';
import HistorialReenganche from '../pages/prestamos/HistorialReenganche';
import PrestamosActivos from '../pages/PrestamosActivos';
import PrestamosAtrasados from '../pages/PrestamosAtrasados';
import PrestamosVencidos from '../pages/PrestamosVencidos';
import Reportes from '../pages/Reportes';
import Exchange from '../pages/Exchange';
import BuroCredito from '../pages/reportes/BuroCredito';
import EstadoCuenta from '../pages/reportes/EstadoCuenta';
import HistorialPrestamos from '../pages/reportes/HistorialPrestamos';
import Incobrables from '../pages/reportes/Incobrables';
import IngresosCapital from '../pages/reportes/IngresosCapital';
import IngresosEgresos from '../pages/reportes/IngresosEgresos';
import PagosPorPrestamos from '../pages/reportes/PagosPorPrestamos';
import PrestamosRealizados from '../pages/reportes/PrestamosRealizados';
import PrestamosRutas from '../pages/reportes/PrestamosRutas';
import PrestamosSaldados from '../pages/reportes/PrestamosSaldados';
import VariacionesCapital from '../pages/reportes/VariacionesCapital';
import VerificarCompromiso from '../pages/reportes/VerificarCompromiso';
import Suplidores from '../pages/Suplidores';
import TiposEgresos from '../pages/TiposEgresos';
import Transacciones from '../pages/Transacciones';
import WhatsApp from '../pages/WhatsApp';
import DashboardMejorado from '../pages/whatsapp/DashboardMejorado';
import ConfiguracionWhatsApp from '../pages/whatsapp/ConfiguracionWhatsApp';
import EnviarMensaje from '../pages/whatsapp/EnviarMensaje';
import Historial from '../pages/whatsapp/Historial';
import Plantillas from '../pages/whatsapp/Plantillas';
import Layout from './Layout';
import PrivateRoute from './PrivateRoute';

// Componente wrapper para pasar el código del tenant al Layout
const TenantLayoutWrapper = ({ children }) => {
  const { codigo } = useParams();
  return (
    <PrivateRoute>
      <Layout tenantCodigo={codigo}>
        {children}
      </Layout>
    </PrivateRoute>
  );
};

// Todas las rutas de tenant con el prefijo /:codigo/
export const getTenantRoutes = () => [
  // Dashboard
  <Route key="dashboard" path="/:codigo/dashboard" element={
    <TenantLayoutWrapper>
      <Dashboard />
    </TenantLayoutWrapper>
  } />,

  // Clientes
  <Route key="clientes-nuevo" path="/:codigo/clientes/nuevo" element={
    <TenantLayoutWrapper>
      <NuevoCliente />
    </TenantLayoutWrapper>
  } />,
  <Route key="clientes-editar" path="/:codigo/clientes/editar" element={
    <TenantLayoutWrapper>
      <EditarCliente />
    </TenantLayoutWrapper>
  } />,
  <Route key="clientes-id-editar" path="/:codigo/clientes/:id/editar" element={
    <TenantLayoutWrapper>
      <EditarCliente />
    </TenantLayoutWrapper>
  } />,
  <Route key="clientes-eliminar" path="/:codigo/clientes/eliminar" element={
    <TenantLayoutWrapper>
      <EliminarCliente />
    </TenantLayoutWrapper>
  } />,
  <Route key="clientes-lista" path="/:codigo/clientes/lista" element={
    <TenantLayoutWrapper>
      <ListaClientes />
    </TenantLayoutWrapper>
  } />,
  <Route key="clientes-detalle" path="/:codigo/clientes/detalle" element={
    <TenantLayoutWrapper>
      <DetalleCliente />
    </TenantLayoutWrapper>
  } />,
  <Route key="clientes-referencia" path="/:codigo/clientes/referencia" element={
    <TenantLayoutWrapper>
      <Referencias />
    </TenantLayoutWrapper>
  } />,

  // Préstamos
  <Route key="prestamos" path="/:codigo/prestamos" element={
    <TenantLayoutWrapper>
      <Prestamos />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-nuevo" path="/:codigo/prestamos/nuevo" element={
    <TenantLayoutWrapper>
      <NuevoPrestamo />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-lista" path="/:codigo/prestamos/lista" element={
    <TenantLayoutWrapper>
      <ListaPrestamos />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-editar" path="/:codigo/prestamos/editar" element={
    <TenantLayoutWrapper>
      <EditarPrestamo />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-eliminar" path="/:codigo/prestamos/eliminar" element={
    <TenantLayoutWrapper>
      <EliminarPrestamo />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-reenganche" path="/:codigo/prestamos/reenganche" element={
    <TenantLayoutWrapper>
      <Reenganche />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-eliminar-reenganche" path="/:codigo/prestamos/eliminar-reenganche" element={
    <TenantLayoutWrapper>
      <EliminarReenganche />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-historial-reenganche" path="/:codigo/prestamos/historial-reenganche" element={
    <TenantLayoutWrapper>
      <HistorialReenganche />
    </TenantLayoutWrapper>
  } />,

  // Pagos
  <Route key="pagos" path="/:codigo/pagos" element={
    <TenantLayoutWrapper>
      <Pagos />
    </TenantLayoutWrapper>
  } />,

  // Excusas
  <Route key="excusas" path="/:codigo/excusas" element={
    <TenantLayoutWrapper>
      <GestionExcusas />
    </TenantLayoutWrapper>
  } />,

  // Rutas
  <Route key="rutas" path="/:codigo/rutas" element={
    <TenantLayoutWrapper>
      <GestionRutas />
    </TenantLayoutWrapper>
  } />,

  // Metas y Comisiones
  <Route key="metas-comisiones" path="/:codigo/metas-comisiones" element={
    <TenantLayoutWrapper>
      <MetasComisiones />
    </TenantLayoutWrapper>
  } />,

  // Reportes
  <Route key="reportes" path="/:codigo/reportes" element={
    <TenantLayoutWrapper>
      <Reportes />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-pagos-prestamos" path="/:codigo/reportes/pagos-prestamos" element={
    <TenantLayoutWrapper>
      <PagosPorPrestamos />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-historial-prestamos" path="/:codigo/reportes/historial-prestamos" element={
    <TenantLayoutWrapper>
      <HistorialPrestamos />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-estado-cuenta" path="/:codigo/reportes/estado-cuenta" element={
    <TenantLayoutWrapper>
      <EstadoCuenta />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-incobrables" path="/:codigo/reportes/incobrables" element={
    <TenantLayoutWrapper>
      <Incobrables />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-ingresos-egresos" path="/:codigo/reportes/ingresos-egresos" element={
    <TenantLayoutWrapper>
      <IngresosEgresos />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-ingresos-capital" path="/:codigo/reportes/ingresos-capital" element={
    <TenantLayoutWrapper>
      <IngresosCapital />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-prestamos-saldados" path="/:codigo/reportes/prestamos-saldados" element={
    <TenantLayoutWrapper>
      <PrestamosSaldados />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-prestamos-realizados" path="/:codigo/reportes/prestamos-realizados" element={
    <TenantLayoutWrapper>
      <PrestamosRealizados />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-prestamos-rutas" path="/:codigo/reportes/prestamos-rutas" element={
    <TenantLayoutWrapper>
      <PrestamosRutas />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-variaciones-capital" path="/:codigo/reportes/variaciones-capital" element={
    <TenantLayoutWrapper>
      <VariacionesCapital />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-verificar-compromiso" path="/:codigo/reportes/verificar-compromiso" element={
    <TenantLayoutWrapper>
      <VerificarCompromiso />
    </TenantLayoutWrapper>
  } />,
  <Route key="reportes-buro-credito" path="/:codigo/reportes/buro-credito" element={
    <TenantLayoutWrapper>
      <BuroCredito />
    </TenantLayoutWrapper>
  } />,

  // Vistas de Préstamos
  <Route key="deben-pagar" path="/:codigo/deben-pagar" element={
    <TenantLayoutWrapper>
      <DebenPagar />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-activos" path="/:codigo/prestamos-activos" element={
    <TenantLayoutWrapper>
      <PrestamosActivos />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-atrasados" path="/:codigo/prestamos-atrasados" element={
    <TenantLayoutWrapper>
      <PrestamosAtrasados />
    </TenantLayoutWrapper>
  } />,
  <Route key="prestamos-vencidos" path="/:codigo/prestamos-vencidos" element={
    <TenantLayoutWrapper>
      <PrestamosVencidos />
    </TenantLayoutWrapper>
  } />,
  <Route key="cobros-hoy" path="/:codigo/cobros-hoy" element={
    <TenantLayoutWrapper>
      <CobrosHoy />
    </TenantLayoutWrapper>
  } />,
  <Route key="por-recoger" path="/:codigo/por-recoger" element={
    <TenantLayoutWrapper>
      <PorRecoger />
    </TenantLayoutWrapper>
  } />,

  // Garantías y Documentos
  <Route key="garantias" path="/:codigo/garantias" element={
    <TenantLayoutWrapper>
      <Garantias />
    </TenantLayoutWrapper>
  } />,
  <Route key="documentos" path="/:codigo/documentos" element={
    <TenantLayoutWrapper>
      <Documentos />
    </TenantLayoutWrapper>
  } />,

  // Finanzas
  <Route key="finanzas" path="/:codigo/finanzas" element={
    <TenantLayoutWrapper>
      <Finanzas />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-gastos" path="/:codigo/finanzas/gastos" element={
    <TenantLayoutWrapper>
      <Gastos />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-caja-chica" path="/:codigo/finanzas/caja-chica" element={
    <TenantLayoutWrapper>
      <CajaChica />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-facturas" path="/:codigo/finanzas/facturas" element={
    <TenantLayoutWrapper>
      <Facturas />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-bancos" path="/:codigo/finanzas/bancos" element={
    <TenantLayoutWrapper>
      <Bancos />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-transacciones" path="/:codigo/finanzas/transacciones" element={
    <TenantLayoutWrapper>
      <Transacciones />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-tipos-egresos" path="/:codigo/finanzas/tipos-egresos" element={
    <TenantLayoutWrapper>
      <TiposEgresos />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-suplidores" path="/:codigo/finanzas/suplidores" element={
    <TenantLayoutWrapper>
      <Suplidores />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-cuadre-caja" path="/:codigo/finanzas/cuadre-caja" element={
    <TenantLayoutWrapper>
      <CuadreCaja />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-flujo-caja" path="/:codigo/finanzas/flujo-caja" element={
    <TenantLayoutWrapper>
      <FlujoCaja />
    </TenantLayoutWrapper>
  } />,
  <Route key="finanzas-cuentas-pagar" path="/:codigo/finanzas/cuentas-pagar" element={
    <TenantLayoutWrapper>
      <CuentasPagar />
    </TenantLayoutWrapper>
  } />,

  // Exchange (solo planes premium)
  <Route key="exchange" path="/:codigo/exchange" element={
    <TenantLayoutWrapper>
      <Exchange />
    </TenantLayoutWrapper>
  } />,

  // Contabilidad
  <Route key="contabilidad" path="/:codigo/contabilidad" element={
    <TenantLayoutWrapper>
      <Contabilidad />
    </TenantLayoutWrapper>
  } />,
  <Route key="contabilidad-cuadre-pagos" path="/:codigo/contabilidad/cuadre-pagos" element={
    <TenantLayoutWrapper>
      <CuadrePagos />
    </TenantLayoutWrapper>
  } />,
  <Route key="contabilidad-cuadre-rutas" path="/:codigo/contabilidad/cuadre-rutas" element={
    <TenantLayoutWrapper>
      <CuadreRutas />
    </TenantLayoutWrapper>
  } />,
  <Route key="contabilidad-calculadora-cuota" path="/:codigo/contabilidad/calculadora-cuota" element={
    <TenantLayoutWrapper>
      <CalculadoraCuota />
    </TenantLayoutWrapper>
  } />,

  // Configuración y Permisos
  <Route key="configuracion" path="/:codigo/configuracion" element={
    <TenantLayoutWrapper>
      <Configuracion />
    </TenantLayoutWrapper>
  } />,
  <Route key="permisos" path="/:codigo/permisos" element={
    <TenantLayoutWrapper>
      <Permisos />
    </TenantLayoutWrapper>
  } />,

  // WhatsApp
  <Route key="whatsapp" path="/:codigo/whatsapp" element={
    <TenantLayoutWrapper>
      <DashboardMejorado />
    </TenantLayoutWrapper>
  } />,
  <Route key="whatsapp-enviar" path="/:codigo/whatsapp/enviar" element={
    <TenantLayoutWrapper>
      <EnviarMensaje />
    </TenantLayoutWrapper>
  } />,
  <Route key="whatsapp-plantillas" path="/:codigo/whatsapp/plantillas" element={
    <TenantLayoutWrapper>
      <Plantillas />
    </TenantLayoutWrapper>
  } />,
  <Route key="whatsapp-historial" path="/:codigo/whatsapp/historial" element={
    <TenantLayoutWrapper>
      <Historial />
    </TenantLayoutWrapper>
  } />,
  <Route key="whatsapp-configuracion" path="/:codigo/whatsapp/configuracion" element={
    <TenantLayoutWrapper>
      <ConfiguracionWhatsApp />
    </TenantLayoutWrapper>
  } />
];
